import {
    REQUEST_FETCH_SPACE_FLIGHTS_LOGS,
    FETCH_SPACE_FLIGHTS_LOGS_SUCCESS,
    FETCH_SPACE_FLIGHTS_LOGS_ERROR,
  } from '../../../actions/reservations/spaceFlight/fetchSpacesFlightsLogs';
    
  const initialState = {
    logs: [],
    processing: false,
    fetching: false,
    message: "",
    error: "",
  };
  
  const spaceFlightsLogReducer = (state = initialState, action) => {
    switch (action.type) {
      case REQUEST_FETCH_SPACE_FLIGHTS_LOGS: {
        return {
          ...state,
          logs: [],
          processing: false,
          fetching: true,
          message: "",
          error: "",
        };
      }
      case FETCH_SPACE_FLIGHTS_LOGS_SUCCESS: {
        return {
          ...state,
          logs: action.logs,
          processing: false,
          fetching: false,
          message: "",
          error: "",
        };
      }
      case FETCH_SPACE_FLIGHTS_LOGS_ERROR: {
        return {
          ...state,
          logs: [],
          processing: false,
          fetching: false,
          message: "",
          error: action.error,
        };
      }
     
      default: {
        return state;
      }
    }
  };
  
  export default spaceFlightsLogReducer;
  